import {
  ProductDetailsBannerItem,
  ProductDetailsCardListItem,
  ProductDetailsFormattedTextItem,
  ProductDetailsImageRowItem,
  ProductDetailsItem,
  ProductDetailsProductListItem,
  ProductDetailsSliderItem,
  ProductDetailsVideoItem
} from '@services';

export const isFormattedText = (item: ProductDetailsItem): item is ProductDetailsFormattedTextItem => (
  Object.prototype.hasOwnProperty.call(item, 'formatted_text')
);

export const isBanner = (item: ProductDetailsItem): item is ProductDetailsBannerItem => (
  Object.prototype.hasOwnProperty.call(item, 'banner')
);

export const isCardList = (item: ProductDetailsItem): item is ProductDetailsCardListItem => (
  Object.prototype.hasOwnProperty.call(item, 'card_list')
);

export const isImageRow = (item: ProductDetailsItem): item is ProductDetailsImageRowItem => (
  Object.prototype.hasOwnProperty.call(item, 'image_row')
);

export const isVideo = (item: ProductDetailsItem): item is ProductDetailsVideoItem => (
  Object.prototype.hasOwnProperty.call(item, 'video')
);

export const isProductList = (item: ProductDetailsItem): item is ProductDetailsProductListItem => (
  Object.prototype.hasOwnProperty.call(item, 'product_list')
);

export const isSlider = (item: ProductDetailsItem): item is ProductDetailsSliderItem => (
  Object.prototype.hasOwnProperty.call(item, 'slider')
);
